/**
 * Product Contents Component
 * Handles click events to open quick-buy modals for product contents
 * Follows the established component architecture with managers.js integration
 */

import ee from '../../ee';

class ProductContents {
  constructor(container = document) {
    this.container = container;
    this.productContentsElements = container.querySelectorAll('product-contents');
    
    // Don't initialize if no product contents exist
    if (!this.productContentsElements.length) return;
    
    this.init();
  }
  
  init() {
    this.initializeProductContents();
    this.bindEvents();
  }
  
  initializeProductContents() {
    this.productContentsElements.forEach(productContentsElement => {
      this.setupProductContents(productContentsElement);
    });
  }
  
  setupProductContents(productContentsElement) {
    // Find all clickable product cards in this product contents (both regular and compact modes)
    const productCards = productContentsElement.querySelectorAll('.product-contents__product-card, .product-contents__product-card--compact');
    
    productCards.forEach(card => {
      // Remove existing listeners to prevent duplicates
      card.removeEventListener('click', this.handleProductClick);
      card.removeEventListener('keydown', this.handleProductKeydown);
      
      // Add event listeners
      card.addEventListener('click', this.handleProductClick.bind(this));
      card.addEventListener('keydown', this.handleProductKeydown.bind(this));
    });
    
    console.log('Product contents initialized with', productCards.length, 'products');
  }

  handleProductClick(event) {
    const card = event.currentTarget;
    const modalId = card.getAttribute('aria-controls');
    
    if (modalId) {
      const modal = document.getElementById(modalId);
      if (modal && modal.show) {
        modal.show();
      } else {
        console.warn('Modal not found or does not have show method:', modalId);
      }
    }
  }

  handleProductKeydown(event) {
    // Handle Enter and Space key presses for accessibility
    if (event.key === 'Enter' || event.key === ' ') {
      event.preventDefault();
      this.handleProductClick(event);
    }
  }
  
  bindEvents() {
    // Listen for theme:loaded event
    ee.addListener('theme:loaded', this.onThemeLoaded.bind(this));
    
    // Listen for section:load to handle dynamic section updates
    document.addEventListener('shopify:section:load', (event) => {
      const newProductContentsElements = event.detail.container.querySelectorAll('product-contents');
      if (newProductContentsElements.length) {
        newProductContentsElements.forEach(productContentsElement => {
          this.setupProductContents(productContentsElement);
        });
      }
    });
  }
  
  onThemeLoaded() {
    // Re-initialize product contents after theme load
    this.productContentsElements = this.container.querySelectorAll('product-contents');
    this.initializeProductContents();
  }
  
  destroy() {
    // Remove event listeners
    ee.removeListener('theme:loaded', this.onThemeLoaded);
    
    // Remove product card event listeners
    this.productContentsElements.forEach(productContentsElement => {
      const productCards = productContentsElement.querySelectorAll('.product-contents__product-card, .product-contents__product-card--compact');
      productCards.forEach(card => {
        card.removeEventListener('click', this.handleProductClick);
        card.removeEventListener('keydown', this.handleProductKeydown);
      });
    });
    
    console.log('Product contents component destroyed');
  }
}

export default ProductContents; 